module.exports = __webpack_public_path__ + "static/media/orange_animal_birds.357da389.webp";